<p>
  icon-refresh works!
</p>
